/**
 * Stable per-browser identifier used to deduplicate blog post views.
 * Stored in localStorage; not tied to any personal data.
 */
const STORAGE_KEY = "blog_view_fp";

export function getBlogViewFingerprint(): string {
  if (typeof window === "undefined") return "";
  try {
    let fp = window.localStorage.getItem(STORAGE_KEY);
    if (!fp) {
      const rand =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      fp = `bv_${rand}`;
      window.localStorage.setItem(STORAGE_KEY, fp);
    }
    return fp;
  } catch {
    // localStorage blocked → fall back to a per-session identifier
    return `bv_session_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  }
}
